/* eslint-disable */
export default {
  unknown: 'Unknown',
  multipleMatches: 'Multiple matches',
  anonymous: 'Anonymous',
  none: 'None',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
